import { REPORTS_DEFAULT_FILTERS } from '@constants/Reports/reportsDefaultToolbar.constants'
import { ReportsTabOption } from '@dataTypes/reports.type'

export const PATIENT_VALUE_REVENUE_FILTERS = REPORTS_DEFAULT_FILTERS

export const PATIENT_VALUE_REVENUE_KPI_DEFINITIONS: Array<{
  id: string
  title: string
  footer: string
  footerMode?:
    | 'percentChange'
    | 'pointChange'
    | 'percentOfPriorBase'
    | 'descriptor'
}> = [
  {
    id: 'avg-ltv',
    title: 'Average patient value (LTV)',
    footer: '',
    footerMode: 'percentChange',
  },
  {
    id: 'active-revenue',
    title: 'Active patient revenue',
    footer: '',
    footerMode: 'percentChange',
  },
  {
    id: 'unscheduled-treatment',
    title: 'Unscheduled treatment',
    footer: '',
    footerMode: 'percentChange',
  },
  {
    id: 'total-outstanding-ar',
    title: 'Total outstanding AR',
    footer: '',
    footerMode: 'percentChange',
  },
]

export const PROCEDURE_MIX_COLORS: Record<string, string> = {
  crown: 'var(--blue-700)',
  srp: 'var(--blue-600)',
  highValue: 'var(--blue-500)',
  filling: 'var(--blue-400)',
  extraction: 'var(--blue-300)',
  others: 'var(--orange-300)',
}

export type NewVsExistingProductionView = 'Patients' | 'Revenue'

export const NEW_VS_EXISTING_VIEW_TABS: ReportsTabOption<NewVsExistingProductionView>[] =
  [
    { label: 'Patients', value: 'Patients' },
    { label: 'Revenue', value: 'Revenue' },
  ]

export type ArUnscheduledOpportunityRow = {
  id: string
  provider: string
  patients: number
  unscheduledValue: string
  outstandingArValue: string
}

export const AR_OPPORTUNITY_CARD_ROW_LIMIT = 6
